import { Controller } from "@hotwired/stimulus"

// Vorlesungsfreie Zeiten im Vertragsformular: add zeigt die leeren Felder für
// eine neue Zeit und tauscht „Hinzufügen“ gegen „Speichern und weitere
// hinzufügen“; warn weist beim Ankreuzen zum Löschen darauf hin, dass die Zeit
// beim Speichern entfällt. Ersetzt admin/contracts.js.erb.
export default class extends Controller {
  static targets = ["fields", "addButton", "saveMoreButton"]
  static values = { message: String }

  add() {
    this.fieldsTargets.forEach((element) => { element.hidden = false })
    if (this.hasAddButtonTarget) this.addButtonTarget.hidden = true
    if (this.hasSaveMoreButtonTarget) this.saveMoreButtonTarget.hidden = false
  }

  warn(event) {
    if (event.target.checked) window.alert(this.messageValue)
  }
}
